import { render } from "./LuckyDraw.vue?vue&type=template&id=5318f62f&scoped=true"
import script from "./LuckyDraw.vue?vue&type=script&lang=js"
export * from "./LuckyDraw.vue?vue&type=script&lang=js"

import "./LuckyDraw.vue?vue&type=style&index=0&id=5318f62f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5318f62f"]])

export default __exports__